<template>
  <v-layout>
    <v-select v-if="isDoorSensor" box dense :single-line="hideDetails" :label="label" :hide-details="hideDetails" v-model="op" :items="itemsDoor" append-icon=""></v-select>
    <v-select v-else-if="isPIRSensor" box dense :single-line="hideDetails" :label="label" :hide-details="hideDetails" v-model="selectedPIR" :items="itemsPIR" append-icon=""></v-select>
    <template v-else>
      <v-flex xs6>
        <operator-selector v-model="op"></operator-selector>
      </v-flex>
      <v-flex xs6 class="pr-0" v-if="isTemperature">
        <v-text-field box mask="####" v-model="th" :rules="rulesThreshold" :hide-details="hideDetails" :label="'°C ' + '(' + thF + '°F)'"></v-text-field>
      </v-flex>
      <v-flex xs6 class="pr-0" v-else-if="isUnderControl">
        <v-text-field box mask="####" v-model="th" :rules="rulesThreshold" :hide-details="hideDetails" :label="thName"></v-text-field>
      </v-flex>
      <v-flex xs6 class="pr-0" v-else>
        <v-text-field box mask="####" v-model="th" :rules="rulesThreshold" :hide-details="hideDetails" :label="$t('reactor.select_threshold')"></v-text-field>
      </v-flex>
    </template>
  </v-layout>
</template>

<script>
import DeviceUnits from '@/components/device/DeviceUnits'
import OperatorSelector from './OperatorSelector'

export default {
  name: 'MacroTriggerItem',
  props: {
    value: {
      type: Object,
      default: () => ({
        op: '!=',
        th: 0
      })
    },
    item: {
      type: Object,
      require: true
    },
    delTrigger: {
      type: String
    },
    'hideDetails': {
      type: Boolean,
      default: true
    },
    label: {
      type: String
    },
    convertFtoU: {
      type: Object,
      default: () => ({
        '11': 1, //Temperature
        '12': 3, //Illumination
        '15': 3, //Humility
        '22': 5, //Smart plug
        '29': 5, //Meter Sensor
      })
    },
  },
  data() {
    return {
      rulesThreshold: [
        v => (parseInt(v) >= 0 && parseInt(v) <= this.thMaximum) || this.$t('reactor.threadhold_between', {
          from: 0,
          to: this.thMaximum
        })
      ],
      op: this.value.op || '!=',
      th: this.value.th / DeviceUnits.factors[this.convertFtoU[this.item.functype] || 3] || 0,
      itemsDoor: [{
        value: '!=',
        text: this.$t('device.open')
      }, {
        value: '=',
        text: this.$t('device.close')
      }],
      itemsPIR: [
        {
          value: '!=',
          text: this.$t('reactor.triggered')
        },
      ],
      selectedPIR: '!='
    }
  },
  components: {
    'operator-selector': OperatorSelector
  },
  computed: {
    isTemperature() {
      return [11].includes(this.item.functype);
    },
    isIllumination() {
      return [12].includes(this.item.functype);
    },
    isUnderControl() {
      return [12, 15, 22, 29].includes(this.item.functype);
    },
    isDoorSensor() {
      return [13].includes(this.item.functype);
    },
    isPIRSensor() {
      return [14, 20].includes(this.item.functype);
    },
    thFactor() {
      return DeviceUnits.factors[this.convertFtoU[this.item.functype] || 3];
    },
    thName() {
      return DeviceUnits.names[this.convertFtoU[this.item.functype]];
    },
    thF() {
      return (this.th * 9 / 5 + 32).toFixed(0);
    },
    thMaximum() {
      if (this.isTemperature || this.isIllumination) {
        return 100;
      } else {
        return 9999;
      }
    }
  },
  watch: {
    op(val) {
      return this.$emit('input', {op: this.op, th: this.th});
    },
    th(val) {
      return this.$emit('input', {op: this.op, th: this.th * this.thFactor});
    },
    delTrigger(val) {
      if (val) {
        this.th = this.value.th / DeviceUnits.factors[this.convertFtoU[this.item.functype] || 3];
        this.op = this.value.op;
      };
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/reactor/MacroTriggerItem.vue